import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import SubTitle from "components/SubTitle";
import { Accordion, Spinner } from "react-bootstrap";
import "./styles.scss";
import { useGetReportLogsQuery } from "features/api/reports/reportsSlice";
import { useReports } from "hooks/useReports";
import { useRole } from "hooks/useRole";
import { UserRole } from "components/Reports/reportAssets/assets";
import { ChangeEntry, reportLogs } from "./types";

const Log = () => {
  const { t } = useTranslation();
  const [showAll, setShowAll] = useState(false);
  const { getReportId } = useReports();
  const reportId = getReportId();
  const role = useRole();
  const {
    data,
    isLoading,
  }: {
    data: reportLogs;
    isLoading: boolean;
  } = useGetReportLogsQuery({
    reportID: reportId,
    role,
  });

  return isLoading ? (
    <div className="loader-container">
      <Spinner animation="border" variant="primary" />
    </div>
  ) : (
    <div className="log-container">
      <SubTitle className="sub-title">{t("reportHistory")}</SubTitle>

      {Object.keys(data)?.length === 0 ? (
        <div>{t("noReportHistory")}</div>
      ) : (
        <Accordion defaultActiveKey={["0"]} alwaysOpen>
          {Object.keys(data).map((date, index) => {
            const dataForDate: ChangeEntry[] = data[date];
            const initialVisibleItems = 5; // Number of items to display initially
            const visibleItems = showAll
              ? dataForDate
              : dataForDate.slice(0, initialVisibleItems);

            return (
              <Accordion.Item
                eventKey={index.toString()}
                key={`Accordion.Item-${date}`}
              >
                <Accordion.Header>{date}</Accordion.Header>
                <Accordion.Body>
                  {visibleItems.map(
                    ({ hour, fullName, changeReport }: ChangeEntry) => (
                      <div className="data-container">
                        <span className="time">{hour}</span>
                        {role !== UserRole.SENIOR_WATCH && (
                          <span className="changer-name">{fullName}</span>
                        )}
                        <span>{changeReport}</span>
                      </div>
                    )
                  )}
                  {dataForDate.length > initialVisibleItems && (
                    <button
                      type="button"
                      className="show-more-button"
                      onClick={() => setShowAll(!showAll)}
                    >
                      {showAll ? t("showLessData") : t("showMoreData")}
                    </button>
                  )}
                </Accordion.Body>
              </Accordion.Item>
            );
          })}
        </Accordion>
      )}
    </div>
  );
};

export default Log;
